import CommentDelete from './CommentDelete';

export default CommentDelete;
